'use client';

import NotFoundMC from '@/components/mc/errors/NotFoundMC';

export default NotFoundMC;
